<template>
  <div class="pc-dialog">
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <!-- <el-form ref="form" :model="teacherList" label-width="80px">
        <el-form-item label="委员会成员"> -->
      <div class="content">
        <h4 class="persontitle">委员会成员</h4>
        <el-select
          v-if="committee.methods == 'add'"
          filterable
          v-model="judgeInfo.value"
          placeholder="请选择成员"
          @change="showJudge"
        >
          <el-option
            v-for="item in teacherList"
            :key="item.id"
            :label="item.chinese_name ? item.chinese_name : item.english_name"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <!-- </el-form-item>
      </el-form> -->

      <div
        class="selectimg"
        :style="`${judgeInfo.value == null ? 'opacity:0' : ''}`"
      >
        <div class="img">
          <img
            :src="judgeInfo.value ? judgeInfo.value.profile_image : ''"
            alt=""
            v-if="judgeInfo.value && judgeInfo.value.profile_image"
          />
        </div>
        <div class="text">
          <h1>{{ judgeInfo.value && judgeInfo.value.chinese_name }}</h1>
          <p>{{ judgeInfo.value && judgeInfo.value.english_name }}</p>
        </div>
      </div>
      <div class="content">
        <h4 class="persontitle">第一轮分组</h4>
        <el-select
          clearable
          v-model="judgeInfo.round1_group"
          placeholder="请选择组"
        >
          <el-option
            v-for="(item, index) in groupList"
            :key="index"
            :label="item.name"
            :value="index + 1"
          >
          </el-option>
        </el-select>
      </div>
      <div class="content">
        <h4 class="persontitle">第二轮分组</h4>
        <el-select
          clearable
          v-model="judgeInfo.round2_group"
          placeholder="请选择组"
        >
          <el-option
            v-for="(item, index) in groupList1"
            :key="index"
            :label="item.name"
            :value="index + 1"
          >
          </el-option>
        </el-select>
      </div>
      <div class="content">
        <h4 class="persontitle">第三轮分组</h4>
        <el-select
          v-model="judgeInfo.round3_group"
          clearable
          placeholder="请选择组"
        >
          <el-option
            v-for="(item, index) in groupList2"
            :key="index"
            :label="item.name"
            :value="index + 1"
          >
          </el-option>
        </el-select>
      </div>

      <button class="btncancel" @click="handleClose">取消</button>
      <button class="btnadd" @click="btnadd">确定</button>
    </el-dialog>
  </div>
</template>



<script>
import { lectureScholarDropDown_Api } from "@/apis/lecture.api.js";
import {
  createCompetitionJudges_Api,
  deleteCompetitionJudges_Api,
  updateCompetitionJudges_Api,
} from "@/apis/competition.api.js";
export default {
  props: {
    dialogVisible: Boolean,
    committee: Object,
  },
  data() {
    return {
      teacherList: null,
      selectimg: "https://picsum.photos/200/200?=random1",
      groupList1: [
        { name: "第一组" },
        { name: "第二组" },
        { name: "第三组" },
        { name: "第四组" },
        { name: "第五组" },
        { name: "第六组" },
        { name: "第七组" },
        { name: "第八组" },
        { name: "第九组" },
        { name: "第十组" },
      ],
      groupList: [
        { name: "第一组" },
        { name: "第二组" },
        { name: "第三组" },
        { name: "第四组" },
        { name: "第五组" },
        { name: "第六组" },
        { name: "第七组" },
        { name: "第八组" },
        { name: "第九组" },
        { name: "第十组" },
      ],
      groupList2: [
        { name: "第一组" },
        { name: "第二组" },
        { name: "第三组" },
        { name: "第四组" },
        { name: "第五组" },
        { name: "第六组" },
        { name: "第七组" },
        { name: "第八组" },
        { name: "第九组" },
        { name: "第十组" },
      ],
      judgeInfo: {
        competition_id: null,
        judge_id: null,
        round1_group: null,
        round2_group: null,
        round3_group: null,
        value: {},
      },
    };
  },
  mounted() {
    this.judgeInfo.competition_id = +this.$route.query.id;
    console.log(this.committee);
    this.judgeInfo.round1_group = this.committee.round1_group
      ? this.committee.round1_group
      : null;
    this.judgeInfo.round2_group = this.committee.round2_group
      ? this.committee.round2_group
      : null;
    this.judgeInfo.round3_group = this.committee.round3_group
      ? this.committee.round3_group
      : null;
    this.judgeInfo.judge_id = this.committee.judge_id;
    this.judgeInfo.value = {
      chinese_name: this.committee.chinese_name,
      english_name: this.committee.english_name,
      profile_image: this.committee.profile_image,
    };
    this.searchScholar();
  },
  methods: {
    showJudge(item) {
      this.judgeInfo.judge_id = item.id;
    },

    handleScholarSelect(item) {
      this.teacherList.scholar = item;
      this.teacherList.scholar_id = item.id;
    },
    searchScholar(queryString) {
      lectureScholarDropDown_Api(queryString ? queryString : "").then((res) => {
        for (let i of res.data) {
          i.value = i.chinese_name;
        }
        this.teacherList = res.data;
      });
    },
    handleClose(done) {
      this.$emit("close");
    },
    btnadd() {
      console.log(this.committee.methods);
      if (this.committee.methods == "update") {
        updateCompetitionJudges_Api(this.judgeInfo)
          .then((res) => {
            this.$global.success(this, "修改成功");
            this.$emit("close");
            this.$emit("getList");
            for (let item in this.judgeInfo) {
              this.judgeInfo[item] = null;
            }
          })
          .catch(() => {
            this.$global.error(this, "修改失败");
          });
      } else {
        this.judgeInfo.judge_english_name = this.judgeInfo.value.english_name;
        this.judgeInfo.judge_chinese_name = this.judgeInfo.value.chinese_name;
        this.judgeInfo.profile_image = this.judgeInfo.value.profile_image;
        createCompetitionJudges_Api(this.judgeInfo)
          .then((res) => {
            console.log(res);
            if (res.code == 205) {
              this.$global.success(this, "添加成功");
              this.$emit("close");
              this.$emit("getList");

              for (let item in this.judgeInfo) {
                this.judgeInfo[item] = null;
              }
            }else{
                            if(res.code == 404){

              this.$global.error(this, "添加失败");
            }
            }
          })
      }
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-dialog {
  .selectimg {
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-left: 115px;
    margin-bottom: 20px;
    .img {
      background: #f9f9f9;
      width: 50px;
      height: 50px;
      border-radius: 100px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .text {
      h1,
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 10px;
        font-family: $chinese;
        color: #646464;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
  // .buttonBox {
  //   display: flex;
  //   justify-content: space-evenly;
  // }

  /deep/ .el-form-item__label {
    white-space: nowrap;
  }
  /deep/ .el-dialog {
    width: 410px;
    min-height: 210px;
  }
  /deep/ .el-icon-close {
    display: none;
  }
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 30px 30px;
    height: 100%;
    position: relative;
    .content {
      display: flex;
      margin-bottom: 20px;
      .persontitle {
        width: 40%;
        margin: 10px 30px 0 0;
        font-family: $chinese;
        font-size: 16px;
        font-weight: bold;
        color: #000000;
      }
      .el-input {
        width: 70%;
      }
    }

    .btncancel,
    .btnadd {
      margin-top: 20px;
      cursor: pointer;
      width: 77px;
      height: 30px;
      border-radius: 4px;
      font-family: $chinese;
      font-size: 12px;
      color: #5a5e66;
      &:hover {
        filter: brightness(105%);
      }
      // &:active {
      //   filter: brightness(110%);
      // }
    }
    .btncancel {
      margin: 0 14px 0 106px;
      border: 1px solid #dcdfe6;
      background: white;
      color: #5a5e66;
    }
    .btnadd {
      border: 1px solid #5470c6;
      background: #5470c6;
      color: white;
    }
    /deep/ .input.el-input__inner {
      width: 269px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/CommitteeDialog.vue